"use client"

import { Layout, LayoutProps } from "antd"
import { FC, RefAttributes } from "react"

const Footer: FC<LayoutProps & RefAttributes<HTMLElement>> = (props) => {
  return (
    <Layout.Footer {...props} />
  )
}

Footer.displayName = 'Footer'

export default Footer